import Tracker from './Tracker'

class Pinterest extends Tracker {
  async init () {
    /* istanbul ignore next */
    // eslint-disable-next-line no-unused-expressions
    !(function (w, d, s, e, n, t, r) {
      if (w.pintrk) return
      w.pintrk = function () {
        w.pintrk.queue.push(Array.prototype.slice.call(arguments))
      }
      n = w.pintrk
      n.version = '3.0'
      n.queue = []
      t = d.createElement(s)
      t.async = !0
      t.src = e
      r = d.getElementsByTagName(s)[0]
      r.parentNode.insertBefore(t, r)
    })(window, document, 'script', 'https://s.pinimg.com/ct/core.js')
  }

  event (event, firstLoad, ...args) {
    window.pintrk(...args)
  }
}

export default Pinterest
